import { Node } from '@tiptap/core';
import { NodeViewWrapper, ReactNodeViewRenderer, ReactNodeViewProps } from '@tiptap/react';

import React from 'react';

import FileContainer from './FileContainer';

type AttachmentNodeAttrs = {
  name: string;
  href: string;
  size?: number;
  mime?: string;
  uploading?: boolean;
  uploadId?: string | null;
  error?: boolean;
  errorMessage?: string | null;
  progress?: number;
  creator?: { name: string; uuid: string };
  created?: string;
  file?: string;
  filename?: string;
  thumbnail?: string;
};

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    attachment: {
      insertAttachment: (attrs: AttachmentNodeAttrs) => ReturnType;
    };
  }
}

const AttachmentNodeComponent: React.FC<ReactNodeViewProps> = ({ node }) =>
  React.createElement(NodeViewWrapper, { contentEditable: false }, React.createElement(FileContainer, { node }));

export const Attachment = Node.create({
  name: 'attachment',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      name: { default: '' },
      href: { default: '' },
      size: { default: null },
      mime: { default: '' },
      uploading: { default: false },
      uploadId: { default: null },
      error: { default: false },
      errorMessage: { default: null },
      progress: { default: 0 },
      creator: { default: null },
      created: { default: null },
      file: { default: '' },
      filename: { default: '' },
      thumbnail: { default: '' },
    };
  },

  parseHTML() {
    return [{ tag: 'attachment-card' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['attachment-card', HTMLAttributes];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AttachmentNodeComponent);
  },

  addCommands() {
    return {
      insertAttachment:
        (attrs) =>
        ({ chain }) =>
          chain().insertContent({ type: this.name, attrs }).run(),
    };
  },
});
